import { Check as CheckIcon, Close as CloseIcon } from "@mui/icons-material";
import { Box, Button } from "@mui/material";
import { useTranslation } from "react-i18next";

type Props = {
  edit: boolean;
  editDisabled?: boolean;
  onCancel: () => void;
  onEdit: () => void;
  onStop: () => void;
  onSave: () => void;
  saveDisabled: boolean;
  stopDisabled?: boolean;
};

const ActionButtons = ({
  edit,
  editDisabled,
  onCancel,
  onEdit,
  onStop,
  onSave,
  saveDisabled,
  stopDisabled = true,
}: Props) => {
  const { t } = useTranslation();

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      marginTop="1rem"
    >
      <Box display="flex" gap="1rem">
        {edit ? (
          <>
            <Button
              disabled={editDisabled}
              sx={{
                borderRadius: "15px",
                maxHeight: "30px",
                color: (theme) => theme.palette.primary.light,
                borderColor: (theme) => theme.palette.primary.light,
                "&:hover": {
                  borderColor: "#6D4AB5E5",
                },
              }}
              startIcon={<CloseIcon />}
              variant="outlined"
              onClick={onEdit}
            >
              {t("talentProfile:setSalary")}
            </Button>
            <Button
              disabled={stopDisabled}
              color="warning"
              sx={{
                borderRadius: "15px",
                maxHeight: "30px",
              }}
              startIcon={<CloseIcon />}
              variant="outlined"
              onClick={onStop}
            >
              {t("talentProfile:stopHiring")}
            </Button>{" "}
          </>
        ) : (
          <Button
            sx={{
              borderRadius: "15px",
              maxHeight: "30px",
            }}
            startIcon={<CloseIcon />}
            variant="outlined"
            onClick={onCancel}
          >
            {t("common:cancelShort")}
          </Button>
        )}
      </Box>
      <Button
        disabled={saveDisabled}
        sx={{ borderRadius: "15px", maxHeight: "30px" }}
        startIcon={<CheckIcon />}
        variant="contained"
        onClick={onSave}
      >
        {t("common:complete")}
      </Button>
    </Box>
  );
};

export default ActionButtons;
